export default "__VITE_ASSET__CYaB5Utz__"